import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';
import {ReservationModel} from '../../reservation-list/reservation-list.component';

@Component({
  selector: 'kt-reservation-per-hour',
  templateUrl: './reservation-per-hour.popup.html',
  styleUrls: ['./reservation-per-hour.popup.scss']
})
export class ReservationPerHourPopup implements OnInit {
  reservationData: ReservationModel[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit() {
    this.reservationData = this.data.data;
  }

}
